module.exports = __webpack_public_path__ + "img/bw.d4647592.png";